import React from "react"
import { useSelector } from "react-redux"
import GameRules from "../../../components/Quiz/GameRules"
import { GameRulesWrapper } from "./styled"
import { skin } from "../../../styles/skin"
import qkLogo from "../../../../media/ard-quizkit-logo.png"

const Rules = () => {

  const game = useSelector(state => state.game)

  return (
    <GameRulesWrapper>
      <GameRules
        bannerImage={game.skin.bannerImage.split(".")[1] === "svg" ? qkLogo : game.skin.bannerImage}
        colors={{
          primary: game.skin.colors.primary,
          primaryFont: game.skin.colors.primaryFont,
          secondary: game.skin.colors.secondary,
          secondaryFont: game.skin.colors.secondaryFont,
        }}
        fonts={{
          primaryFont: game.skin.primaryFont,
          secondaryFont: game.skin.secondaryFont
        }}
        gameMode={game.gameMode}
        quizTagline={game.tagline}
        quizTitle={game.title}
        logoIsVisible={false}
        // rules={rules}
      />
    </GameRulesWrapper>
  )
}

export default Rules
